<app-form-results
    [indexList] = "indexList"
    [systemList] = "systemList"
    [propertiesList] = "propertiesList"
    [propBskList] = "propBskList"
    [groupList]="groupList"
    [userList]="userList"               
    [result]="selectedResult"
    [resultItemList]="resultItem"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)">
</app-form-results>
